<div class="full-page w-100 px-0 h-100">
  <div class="login-container h-100">
    <img class="logo" src="assets/images/login-registration/my-albion-rewards-logo.png" draggable="false" />

    <div class="login-details rounded">
      <h4 class="mb-0">{{ 'login.page.title' | translate }}</h4>
      <div class="font-size-14">{{ 'login.page.description' | translate }}</div>
      <!-- <fgb-sports-alliance-user-login class="w-100"></fgb-sports-alliance-user-login> -->
      <fgb-fusion-user-login class="w-100"></fgb-fusion-user-login>

      <ng-container *ngIf="errorCode$ | async as errorCode">
        <div class="text-danger text-center mt-2 fw-bold">
          {{ errorCode | translate }}
        </div>
      </ng-container>
    </div>
  </div>
</div>
